import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useZipCodeFromUser from 'global-state/zipCodeFromUser/useZipCodeFromUser';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
const PDPAddToBagButton = t0 => {
  const $ = _c(16);
  const {
    addingToCart: t1,
    addToCartError: t2,
    campaign,
    cartDisabled: t3,
    isStickyButton: t4,
    isCustomizeButton: t5,
    loading: t6,
    onClick,
    show: t7
  } = t0;
  const addingToCart = t1 === undefined ? false : t1;
  const addToCartError = t2 === undefined ? null : t2;
  const cartDisabled = t3 === undefined ? false : t3;
  const isStickyButton = t4 === undefined ? false : t4;
  const isCustomizeButton = t5 === undefined ? false : t5;
  const loading = t6 === undefined ? false : t6;
  const show = t7 === undefined ? true : t7;
  const zipCodeFromUser = useZipCodeFromUser();
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  if (loading) {
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Placeholder type="rect" loading={true} style={{
        height: "44px"
      }} />;
      $[0] = t8;
    } else {
      t8 = $[0];
    }
    return t8;
  }
  const t8 = !!zipCodeFromUser && !isZipCodeFromUserServiceable || addingToCart || cartDisabled;
  let t9;
  if ($[1] !== isStickyButton || $[2] !== onClick) {
    t9 = event => onClick(event, isStickyButton);
    $[1] = isStickyButton;
    $[2] = onClick;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const t10 = campaign === "barbie" ? "hotpink" : "black";
  const t11 = !show ? "-1" : undefined;
  const t12 = isCustomizeButton ? "Customize" : "Add to Bag";
  let t13;
  if ($[4] !== addingToCart || $[5] !== t10 || $[6] !== t11 || $[7] !== t12 || $[8] !== t8 || $[9] !== t9) {
    t13 = <CtaButton disabled={t8} data-xc="add-cart-sticky-footer-button" onClick={t9} styling="solid-button" color={t10} block={true} tabIndex={t11} isLoading={addingToCart} className="min-w-[120px] px-4">{t12}</CtaButton>;
    $[4] = addingToCart;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t8;
    $[9] = t9;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== addToCartError) {
    t14 = addToCartError && <div className="text-sm font-bold text-red mt-4 text-center">{addToCartError}</div>;
    $[11] = addToCartError;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== t13 || $[14] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  return t15;
};
PDPAddToBagButton.propTypes = {
  addingToCart: PropTypes.bool,
  addToCartError: PropTypes.string,
  campaign: PropTypes.string,
  cartDisabled: PropTypes.bool,
  isCustomizeButton: PropTypes.bool,
  isStickyButton: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  show: PropTypes.bool
};
export default PDPAddToBagButton;